const ASSETS_URL_KEYS = ['assets_url', 'cdn_url', 'static_url']

const normalizeBaseUrl = (url: string): string => {
    if (!url) return ''
    const sanitized = url.replace(/\/\.\//g, '/')
    return sanitized.endsWith('/') ? sanitized.slice(0, -1) : sanitized
}

const parseExtParams = (rawExtParams: string): Record<string, string> => {
    if (!rawExtParams) return {}

    try {
        const decoded = decodeURIComponent(rawExtParams)
        const parsedJson = JSON.parse(decoded)
        if (parsedJson && typeof parsedJson === 'object') {
            return parsedJson
        }
    } catch (error) {
        // ignored: ext_params might not be JSON
    }

    try {
        const decoded = decodeURIComponent(rawExtParams)
        const params = new URLSearchParams(decoded)
        const result: Record<string, string> = {}

        for (const [key, value] of params.entries()) {
            result[key] = value
        }

        return result
    } catch (error) {
        return {}
    }
}

export const getAssetsBaseUrl = (): string => {
    const searchParams = new URLSearchParams(window.location.search)

    for (const key of ASSETS_URL_KEYS) {
        const directValue = searchParams.get(key)
        if (directValue) return normalizeBaseUrl(directValue)
    }

    const extParamsRaw = searchParams.get('ext_params') || ''
    const extParams = parseExtParams(extParamsRaw)
    for (const key of ASSETS_URL_KEYS) {
        if (extParams[key]) return normalizeBaseUrl(extParams[key])
    }

    if (process.env.ASSETS_URL) {
        return normalizeBaseUrl(process.env.ASSETS_URL)
    }

    return ''
}

export const buildAssetUrl = (assetPath: string): string => {
    const normalizedPath = (assetPath.startsWith('/') ? assetPath : `/${assetPath}`).replace(/\/\.\//g, '/')
    const baseUrl = getAssetsBaseUrl()

    if (!baseUrl) {
        return `.${normalizedPath}`
    }

    const baseIncludesAssetsRoot = /\/assets$/i.test(baseUrl)
    const pathStartsWithAssetsRoot = /^\/assets\//i.test(normalizedPath)
    const pathWithoutDuplicatedAssetsRoot =
        baseIncludesAssetsRoot && pathStartsWithAssetsRoot ? normalizedPath.replace(/^\/assets/i, '') : normalizedPath

    return `${baseUrl}${pathWithoutDuplicatedAssetsRoot}`
}
